import React from 'react'
import { useAppDispatch } from 'app/hooks'
import { showTerms } from 'app/thunks'
import FilterCollapse from '@feature/FilterCollapse'
import TaxonomyChoices from '@feature/TaxonomyChoices'
import { TaxonomyId, TaxonomyState } from 'types'

type TaxonomyCollapseProps<T extends TaxonomyId> = {
  taxonomy: TaxonomyState<T>
}

const TaxonomyCollapse = <T extends TaxonomyId>({ taxonomy }: TaxonomyCollapseProps<T>) => {

  const dispatch = useAppDispatch()

  const {
    taxonomyId,
    label,
    termsLoaded,
    selections,
    boolean,
  } = taxonomy

  const handleCollapse = (collapsed: boolean) => {
    if (!collapsed) dispatch(showTerms(taxonomyId))
  }

  React.useEffect(() => {
    if(boolean && !termsLoaded) dispatch(showTerms(taxonomyId))
  }, [boolean, dispatch, termsLoaded, taxonomyId])

  return boolean ? (
    <TaxonomyChoices {...taxonomy} />
  ) : (
    <FilterCollapse label={label} onCollapse={handleCollapse} count={selections.length}>
      <TaxonomyChoices {...taxonomy}/>
    </FilterCollapse>
  )
}

export default TaxonomyCollapse
